import dispatcher from "./dispatcher";
import actionTypes from "./constants";
import axios from "axios";

/** Shared in-flight request so parallel empty-store callers share one HTTP call. */
let publishersRequest = null;

export async function getPublishers() {
  if (publishersRequest) {
    return publishersRequest;
  }

  publishersRequest = axios
    .get(process.env.REACT_APP_API_URL + "publisher/list/all", {
      data: {},
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((apiData) => {
      dispatcher.dispatch({
        actionTypes: actionTypes.GET_PUBLISHER_DATA,
        posts: apiData.data,
      });
      return apiData;
    })
    .finally(() => {
      publishersRequest = null;
    });

  return publishersRequest;
}
